// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
const { TYPES: modelTypes } = require('shared/model-types')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { COLLECTION_FOLLOWING_CHANGE_PENDING } = require('client-v2/common/models/collection/actions')
const { INTEREST_FOLLOWING_CHANGE_PENDING } = require('client-v2/common/models/interest/actions')
const { USER_FOLLOWING_CHANGE_PENDING } = require('client-v2/common/models/user/actions')

const bem = BemEntity('ModelToggleButton')

function ModelToggleButton(props) {
  const {
    pending, checked, unchecked,
    label, title, action
  } = modelTypeProps(props)
  return tag(props.as, {
    className: classNames(
      props.className,
      bem.block({
        action,
        pending,
        checked,
        unchecked
      })
    ),
    title,
    forwardedRef: props.forwardedRef,
    onClick: pending ? null : props.onClick
  },
    tag('label', {
      className: bem.element('label')
    },
      label
    )
  )
}

const propsByModelType = {
  [modelTypes.ARTICLE]: {
    action: 'add',
    uncheckedLabel: 'Add',
    uncheckedTitle: 'Add this Article to your Collections',
    checkedLabel: 'Added',
    checkedTitle: 'Move or Remove this Article in your Collections'
  },
  [modelTypes.INTEREST]: {
    action: 'follow',
    uncheckedLabel: 'Follow',
    uncheckedTitle: 'Follow this Interest to see more like this',
    checkedLabel: 'Following',
    checkedTitle: 'You are following this Interest',
    pendingValue: INTEREST_FOLLOWING_CHANGE_PENDING
  },
  [modelTypes.MIX]: {
    action: 'subscribe',
    uncheckedLabel: 'Subscribe',
    uncheckedTitle: 'Subscribe to this Collection',
    checkedLabel: 'Subscribed',
    checkedTitle: 'You are subscribed to this Collection',
    pendingValue: COLLECTION_FOLLOWING_CHANGE_PENDING
  },
  [modelTypes.USER]: {
    action: 'follow',
    uncheckedLabel: 'Follow',
    uncheckedTitle: 'Follow this User to see more of their Posts',
    checkedLabel: 'Following',
    checkedTitle: 'You are following this User',
    pendingValue: USER_FOLLOWING_CHANGE_PENDING
  }
}

function modelTypeProps({ modelType, checked }) {
  const modelTypeProps = propsByModelType[modelType]
  if (checked === modelTypeProps.pendingValue) {
    return {
      pending: true,
      label: '',
      title: 'Just a second...'
    }
  }
  if (checked) {
    return {
      checked: true,
      label: modelTypeProps.checkedLabel,
      title: modelTypeProps.checkedTitle,
      action: modelTypeProps.action
    }
  }
  return {
    unchecked: true,
    label: modelTypeProps.uncheckedLabel,
    title: modelTypeProps.uncheckedTitle,
    action: modelTypeProps.action
  }
}

const checkedValues = [
  true,
  false,
  COLLECTION_FOLLOWING_CHANGE_PENDING,
  INTEREST_FOLLOWING_CHANGE_PENDING,
  USER_FOLLOWING_CHANGE_PENDING
]

const modelTypeValues = [
  modelTypes.ARTICLE,
  modelTypes.INTEREST,
  modelTypes.MIX,
  modelTypes.USER
]

ModelToggleButton.propTypes = {
  // Values
  as: PropTypes.elementType.isRequired,
  className: PropTypes.string,
  checked: PropTypes.oneOf(checkedValues).isRequired,
  forwardedRef: PropTypes.func,
  modelType: PropTypes.oneOf(modelTypeValues).isRequired,
  onClick: PropTypes.func.isRequired
}

ModelToggleButton.withModelToggle = (modelType, buttonComponent) => {
  const highOrderComponent = props => {
    return tag(ModelToggleButton, {
      ...props,
      as: buttonComponent,
      modelType
    })
  }
  const buttonName = buttonComponent.displayName || buttonComponent.name
  highOrderComponent.displayName = `withModelToggle(${buttonName}, ${modelType})`
  return highOrderComponent
}

module.exports = ModelToggleButton
